import React, { FC, useEffect, useState } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { Box } from '@mui/material'
import { app } from 'config'
import { storage } from 'utils'
import { BlankLayout, ErrorBoundary, Loader } from '../../'
import { BaseLayoutHeader } from './components'
import useStyle from './base-layout-style'

interface IProps {
  maxWidth?: string
  children?: JSX.Element | JSX.Element[]
  boxLayoutClassName?: string
}

const BaseLayout: FC<IProps> = ({ maxWidth, children, boxLayoutClassName }) => {
  const authData = useOktaAuth()
  const { classes } = useStyle()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    storage.setUser()
    if (authData && authData.authState) {
      setIsLoading(false)
    }
  }, [authData])

  if (isLoading) {
    return (
      <BlankLayout data-testid="blank-layout">
        <Loader />
      </BlankLayout>
    )
  }

  if (!authData || !authData.authState || authData.authState.isPending) {
    return (
      <BlankLayout data-testid="blank-layout">
        <Loader />
      </BlankLayout>
    )
  }

  return (
    <ErrorBoundary>
      <Box
        className={classes.root}
        sx={{
          width: '100%',
          maxWidth: '100vw',
          overflowX: 'hidden',
        }}
      >
        <BaseLayoutHeader />
        <Box
          sx={{
            width: '100%',
            maxWidth: maxWidth || app.layoutAndModuleWidth,
            mx: 'auto',
            my: { xs: 3, sm: 4, md: 5 },
            px: { xs: 2, sm: 3 },
            boxSizing: 'border-box',
          }}
          className={boxLayoutClassName}
        >
          {children}
        </Box>
      </Box>
    </ErrorBoundary>
  )
}

export default BaseLayout
